import { Box, Stack } from '@mui/material'
import { memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import Popup from '../../shared/popup/Popup'
import Text from '../../shared/text/Text'
import { STAKING_APY } from '../../../util/staking/staking.helpers'
import { Image } from '../../shared/image'
import ProvidersGrid from '../../overview/ProvidersGrid'

const Notification = ({
  symbol,
  onSubmit,
  onCancel,
  title,
  desc,
  banner,
  noSubmit = false,
  noProviders = false
}) => {
  const { t } = useTranslation()
  return (
    <Popup
      title={t(title)}
      description={t(desc, { symbol, apy: STAKING_APY })}
      submitLabel={!noSubmit && t('how-it-works.stake-your')}
      cancelLabel={t('common.close')}
      onFormSubmit={!noSubmit && onSubmit}
      onCancel={onCancel}
      disableClose
      banner={
        <Image src={banner} sx={{ aspectRatio: '2/1', minHeight: 140 }} />
      }
    >
      <Stack spacing={1.5}>
        <Text
          label={`${t('notification.top-benefits')}: `}
          variant='subtitle2'
          sx={{ mb: 1 }}
        />
        <Box component='ul' pl={2.8}>
          {t('notification.top-benefits-list', { returnObjects: true }).map(
            (_, index) => (
              <li key={index}>
                <Text
                  label={
                    <Trans
                      i18nKey={`notification.top-benefits-list.${index}`}
                      values={{ apy: STAKING_APY }}
                    />
                  }
                />
              </li>
            )
          )}
        </Box>
        {!noProviders && (
          <>
            <Text
              label={`${t('notification.get-for-staking')}: `}
              variant='subtitle2'
              sx={{ mt: 2 }}
            />
            <ProvidersGrid size={3} spacing={1} />
          </>
        )}
      </Stack>
    </Popup>
  )
}

export default memo(Notification)
